module.exports = __webpack_public_path__ + "img/you.28fb5d9f.png";